const getKnowledgeLevel = number => {
  switch (number) {
    case 0:
      return 'Nenhum';
    case 1:
      return 'Teórico';
    case 3:
      return 'Pontual';
    case 5:
      return 'Cotidiano';
    case 8:
      return 'Domínio';
    case 13:
      return 'Referência';
    default:
      return 'Não informado';
  }
};

const knowledgeLevelInsideArray = (punctuation, options, alternatives) => {
  const knowledgeValue = alternatives?.map((alternative, index) => ({
    value: alternative,
    option: options[index],
  }));

  const returnedValue = knowledgeValue?.filter(
    ({ value }) => value === punctuation,
  );

  return returnedValue && returnedValue[0]?.option;
};

const toBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

const generateSendObject = data =>
  Array(data).map(
    ({
      id_avaliacao: idAvaliacao,
      id_funcionario_avaliado: idFuncionario,
      descricao_tipo_avaliacao: descricao,
      respostas,
    }) => {
      const reduceAnswers = respostas.map(
        ({ id_area_template: idArea, blocos }) => {
          const reduceBlocks = blocos.map(
            ({ id_bloco_template: idBloco, questoes }) => {
              const reduceQuestions = questoes.map(
                ({
                  id_questao_template: idQuestao,
                  pontuacao,
                  certificado: certificate,
                }) => ({
                  id_questao: idQuestao,
                  resposta: pontuacao,
                  tem_certificado: certificate === 1,
                }),
              );

              return {
                id_bloco: idBloco,
                questoes: reduceQuestions,
              };
            },
          );

          return {
            id_area: idArea,
            blocos: reduceBlocks,
          };
        },
      );

      return {
        id_avaliacao: idAvaliacao,
        id_funcionario: idFuncionario,
        descricao_tipo_avaliacao: descricao,
        respostas: reduceAnswers,
      };
    },
  );

export {
  getKnowledgeLevel,
  toBase64,
  generateSendObject,
  knowledgeLevelInsideArray,
};
